import { WHATSAPP_TEMPLATE_BUTTON_TYPES } from 'cpool-constants';
import { z } from 'zod';

export const schemaWhatsAppTemplateButton = z.discriminatedUnion('type', [
    z.object({ text: z.string().min(1), type: z.literal(WHATSAPP_TEMPLATE_BUTTON_TYPES.QUICK_REPLY) }),
    z.object({
        hasDynamicSuffix: z.boolean(),
        text: z.string().min(1),
        type: z.literal(WHATSAPP_TEMPLATE_BUTTON_TYPES.URL),
        url: z.string().min(1),
    }),
    z.object({
        phoneNumber: z.string().min(1),
        text: z.string().min(1),
        type: z.literal(WHATSAPP_TEMPLATE_BUTTON_TYPES.PHONE_NUMBER),
    }),
    // Unmodeled kind, kept only to hold its array position (the button index).
    z.object({
        metaType: z.string().min(1),
        text: z.string(), // not .min(1): Meta omits a label on some unmodeled kinds
        type: z.literal(WHATSAPP_TEMPLATE_BUTTON_TYPES.UNKNOWN),
    }),
]);

export type Schema_WhatsAppTemplateButton = z.infer<typeof schemaWhatsAppTemplateButton>;
